import { BulkAction } from 'src/app/shared/interfaces'

import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core'
import { DataTable } from '@pascalhonegger/ng-datatable'

import { Organization } from '../organization'
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { Subject } from 'rxjs'
import { Store } from '@ngrx/store'
import { AppState } from '../../../core/core.state'
import { Constants } from '../../../shared/constants'
import { organizationActions } from '../organization.actions'
import { organizationSelectors } from '../organization.selectors'
import DEBOUNCED_TIME = Constants.DEBOUNCED_TIME

@UntilDestroy()
@Component({
  selector: 'organization-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class OrganizationTableComponent {
  @Input() tableData: Organization[]
  @Input() bulkActions: BulkAction[] = []
  @Output() onBulkAction = new EventEmitter<any>()
  @Output() onClickRow = new EventEmitter<any>()
  @Input() isLoading = false

  @ViewChild('dataTable', { static: true }) dataTable: DataTable

  public filterTerm: string = ''
  public allCheckedToggle: boolean = false
  public checkedIds: Map<number, boolean> = new Map()
  public searchTerm$ = new Subject<string>()

  public total$ = this.store.select(organizationSelectors.selectCount)

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.searchTerm$
      .pipe(
        distinctUntilChanged(),
        debounceTime(DEBOUNCED_TIME),
        untilDestroyed(this),
        filter((s) => s.length > 2)
      )
      .subscribe((term) => {
        this.store.dispatch(
          organizationActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: {
                $or: [
                  {
                    description: {
                      [CondOperator.CONTAINS_LOW]: term
                    }
                  },
                  {
                    additionalDescription: {
                      [CondOperator.CONTAINS_LOW]: term
                    }
                  },
                  {
                    email: {
                      [CondOperator.CONTAINS_LOW]: term
                    }
                  },
                  {
                    commercialCode: {
                      [CondOperator.CONTAINS_LOW]: term
                    }
                  },
                  {
                    organisationCode: {
                      [CondOperator.CONTAINS_LOW]: term
                    }
                  },
                  {
                    organisationSecondaryCode: {
                      [CondOperator.CONTAINS_LOW]: term
                    }
                  }
                ]
              }
            })
          })
        )
      })
  }

  public onRowClicked(row: Organization) {
    this.onClickRow.emit(row)
  }

  public onCheckRow(targetRow: Organization) {
    this.checkedIds.set(
      targetRow.id,
      !Boolean(this.checkedIds.get(targetRow.id))
    )
  }

  public onToggleAllChecked() {
    this.allCheckedToggle = !this.allCheckedToggle

    this.dataTable.data.forEach((row) =>
      this.checkedIds.set(row.id, this.allCheckedToggle)
    )
  }

  public onClickBulkAction(bulkOption: string) {
    const rows: Location[] = this.dataTable.data.filter((x) =>
      this.checkedIds.get(x.id)
    )

    if (rows.length > 0) {
      this.onBulkAction.emit({ action: bulkOption, items: rows })
    }
  }

  public onSearch(value) {
    this.searchTerm$.next(value)
  }
}
